import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sql_view = _resolveComponent("sql-view")!

  return (_ctx.options)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", null, "Other graph papers by " + _toDisplayString(_ctx.options.author.name), 1),
        _createVNode(_component_sql_view, {
          ids: _ctx.options.contextIds,
          sql: _ctx.sql
        }, null, 8, ["ids", "sql"]),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
          class: "button-gray mt-4"
        }, " Back ")
      ]))
    : _createCommentVNode("", true)
}